import { Link } from 'react-router-dom';
import styles from './BlogTeaser.module.css';
import { SectionWrapper } from '../shared/SectionWrapper';
import { Chip } from '../shared/Chip';
import { ScriptText } from '../shared/ScriptText';
import { blogPosts } from '../../data/blog-posts';

const teaserPosts = blogPosts.slice(0, 3);

export function BlogTeaser() {
  return (
    <SectionWrapper className={styles.section}>
      <div className={styles.header}>
        <Chip>From the Journal</Chip>
        <h2 className={`display ${styles.title}`}>
          Words on <ScriptText rotate={-2}>love.</ScriptText>
        </h2>
      </div>

      <div className={styles.grid}>
        {teaserPosts.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className={styles.card}>
            <div className={styles.cardImage} style={{ background: `linear-gradient(135deg, ${p.hue}22, var(--bg))` }}>
              <span className={styles.kicker}>{p.kicker}</span>
              <span className={styles.emoji}>{p.emoji}</span>
            </div>
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{p.title}</h3>
              <span className={styles.readTime}>{p.readTime}</span>
            </div>
          </Link>
        ))}
      </div>
    </SectionWrapper>
  );
}
